module.exports = __webpack_public_path__ + "static/hostelworld.9908daed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sponsors/logos/hostelworld.svg
// module id = 725
// module chunks = 213534597649335